import Env from '@opsbase/lib-env';
import Pane from '@opsbase/web-layout/Pane';
import GoogleMapReact from 'google-map-react';
import React from 'react';
export function GoogleMap(props) {
    const { location, staticMap = false, zoom = 14, width = 198, height = 198 } = props;
    let locationObj = undefined;
    try {
        locationObj = JSON.parse(location);
    }
    catch (_a) { }
    let mapPosition;
    if (locationObj) {
        mapPosition = {
            lat: parseFloat(locationObj.coords.latitude),
            lng: parseFloat(locationObj.coords.longitude),
        };
    }
    const handleGoogleApiLoaded = (map, maps) => {
        const geocoder = new maps.Geocoder();
        const marker = new maps.Marker({
            position: mapPosition,
            map,
            title: 'Op performed',
        });
        geocoder.geocode({ location: mapPosition }, ([place], status) => {
            if (status === maps.GeocoderStatus.OK && place) {
                const infowindow = new maps.InfoWindow({
                    content: place.formatted_address,
                });
                infowindow.open(map, marker);
                marker.addListener('click', () => {
                    infowindow.open(map, marker);
                });
            }
        });
    };
    if (staticMap) {
        const src = 'http://maps.googleapis.com/maps/api/staticmap?' +
            'center=' +
            mapPosition.lat +
            ',' +
            mapPosition.lng +
            '&' +
            'markers=' +
            mapPosition.lat +
            ',' +
            mapPosition.lng +
            '&' +
            'zoom=' +
            zoom +
            '&' +
            'size=' +
            width +
            'x' +
            height +
            '&' +
            'maptype=roadmap&' +
            'key=' +
            Env.googleMap.apiKey;
        return React.createElement("img", { alt: "Map", src: src, style: { width: '100%' } });
    }
    return (React.createElement(Pane, { style: { width, height } },
        React.createElement(GoogleMapReact, { bootstrapURLKeys: {
                key: Env.googleMap.apiKey,
                language: 'en',
            }, defaultCenter: mapPosition, center: mapPosition, defaultZoom: zoom, onGoogleApiLoaded: ({ map, maps }) => handleGoogleApiLoaded(map, maps), yesIWantToUseGoogleMapApiInternals: true })));
}
export default GoogleMap;
